export const areaWithUnit = (area?: number, countryCode?: string): string | undefined => {
  if (area === undefined) return undefined;

  if (countryCode === 'US') {
    return squareMeterToCustomaryUnits(area);
  } else {
    return squareMeterToMetricUnits(area);
  }
}

export const squareMeterToCustomaryUnits = (area: number): string => {
  if (area >= 2_589_988) {
    return significantDigits(area / 2_589_988) + ' mi²';
  }
  return significantDigits(area / 4_047) + ' acre';
}

export const squareMeterToMetricUnits = (area: number): string => {
  if (area >= 1_000_000) {
    return significantDigits(area / 1_000_000) + ' km²';
  } else if (area >= 10_000) {
    return significantDigits(area / 10_000) + ' ha';
  } else {
    return significantDigits(area) + ' m²';
  }
}

const significantDigits = (value: number): string => {
  if (value >= 1000) return value.toFixed(0);
  return value.toPrecision(3);
}
